import React, { useEffect, useState } from "react";


const LenderInformation = () => {
  
  return (
    <>
        <section
      className=" rounded"
      style={{ background: "#eeeeee", minHeight: "100vh" }}
    >
       
 <div className="mt-2 p-4">
    <h2 className="bg-secondary p-4 rounded-top font-weight-bold text-dark">
      Lender Information
    </h2>
    <div className="bg-white">
    <form className="py-5 bg-white col-sm-6 p-3 rounded">
      <div>
        <div className="row">
          <div className="col-12 mb-4">
            <label htmlFor="lname" className="form-label" required>
              Lender Name
            </label>
            <input
              id="lname"
              name="lname"
              type="text"
              className="form-control"
            />
          </div>
          <div className="col-12 mb-4">
            <label htmlFor="address" className="form-label" required>
              Mailing Address
            </label>
            <input
              id="address"
              name="address"
              type="text"
              className="form-control"
            />
          </div>
          <div className="d-flex" style={{gap: "10px"}}>
                <div className="col-4 mb-4">
                <label htmlFor="homePhone" className="form-label" required>
                    Home Phone
                </label>
                <input
                    id="homePhone"
                    name="homePhone"
                    type="text"
                    className="form-control"
                />
                </div>
                <div className="col-4 mb-4">
                <label htmlFor="workPhone" className="form-label" required>
                    Work Phone
                </label>
                <input
                    id="workPhone"
                    name="workPhone"
                    type="text"
                    className="form-control"
                />
                </div>
                <div className="col-4 mb-4">
                <label htmlFor="cellPhone" className="form-label" required>
                    Cell Phone
                </label>
                <input
                    id="cellPhone"
                    name="cellPhone"
                    type="text"
                    className="form-control"
                />
                </div>
          </div>
          <div className="col-6 mb-4">
            <label htmlFor="email" className="form-label" required>
                Email
            </label>
            <input
                id="email"
                name="email"
                type="email"
                className="form-control"
            />
        </div>
        <div className="col-6 mb-4">
            <label htmlFor="taxId" className="form-label" required>
                SSN / Tax ID
            </label>
            <input
                id="taxId"
                name="taxId"
                type="text"
                className="form-control"
            />
        </div>

        </div>
      </div>
      <div className="mt-5">
        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </div>
    </form>
  </div>
  </div>
  </section>
    </>
  );
};

export default LenderInformation;